import { useLocation } from 'react-router-dom';

import { Sidebar, Header, SubHeader } from 'src/components';
import { AllRoutes } from 'src/Router/AllRoutes';

interface IDashboardContainerProps {
  children: React.ReactNode;
}

const index = ({ children }: IDashboardContainerProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const location = useLocation();

  let currentPageName: any = AllRoutes?.find(
    (route: any) =>
      route.path + '/' === location.pathname || route.path === location.pathname
  )?.title;

  if (!currentPageName) {
    currentPageName = AllRoutes?.find(
      (route: any) =>
        route.path.split('/').length > 3 &&
        route.path.split('/')[3] === location.pathname.split('/')[3]
    )?.title;
  }

  if (!currentPageName) {
    currentPageName = AllRoutes?.find(
      (route: any) =>
        route.path.split('/').length > 2 &&
        route.path.split('/')[2] === location.pathname.split('/')[2]
    )?.title;
  }

  return (
    <div className="h-screen flex flex-col">
      <Header />
      <div
        className={`flex-1 grid  bg-[#F2F2F2] grid-cols-[109px_minmax(0,_1fr)] ${
          currentPageName !== 'Timeline' && 'overflow-hidden'
        }`}
      >
        <aside className="bg-white overflow-y-auto border-r w-[109px] border-r-[#DCDFE4] ">
          <Sidebar />
        </aside>
        <main className="flex flex-col overflow-hidden overflow-y-auto ">
          <SubHeader title={currentPageName} />
          <div className="flex-1 overflow-y-auto bg-white pl-10  ">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default index;
